var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "quantity" }, [
    _c(
      "button",
      {
        staticClass: "quantity__decrease",
        attrs: {
          "aria-label": "Decrease item quantity",
          disabled: _vm.quantity <= _vm.min,
        },
        on: {
          click: function ($event) {
            return _vm.decreaseQuantity()
          },
        },
      },
      [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              "stroke-width": "1.5",
              stroke: "currentColor",
            },
          },
          [
            _c("path", {
              attrs: {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M5 12h14",
              },
            }),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c("p", { staticClass: "quantity__amount" }, [
      _vm._v("\n    " + _vm._s(_vm.quantity) + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "quantity__increase",
        attrs: {
          "aria-label": "Increase item quantity",
          disabled: _vm.max && _vm.quantity >= _vm.max,
        },
        on: {
          click: function ($event) {
            return _vm.increaseQuantity()
          },
        },
      },
      [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              "stroke-width": "1.5",
              stroke: "currentColor",
            },
          },
          [
            _c("path", {
              attrs: {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M12 4.5v15m7.5-7.5h-15",
              },
            }),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }